export default __webpack_public_path__ + "static/paBTvnyO-0144161fcef79e9ccd65bb3d65bfaabb.svg";